module.exports = __webpack_public_path__ + "img/discord.cf4ab315.svg";